<template>
  <v-btn
    prepend-icon="mdi-content-save"
    :color="computedColor">
    {{ computedText }}
  </v-btn>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps(['color', 'text']);

const computedColor = computed(() => {
  return !props.color ? 'primary' : props.color;
});

const computedText = computed(() => {
  return !props.text ? 'SAVE' : props.text;
});
</script>
